import * as React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { SetupBusinessForm } from './SetupBusinessForm';

type SetupBusinessModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const SetupBusinessModal: React.FC<SetupBusinessModalProps> = ({
  isOpen,
  onClose,
}) => {
  const history = useHistory();
  return (
    <Modal size="lg" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <SetupBusinessForm
            afterSetup={() => {
              history.push('/');
              onClose();
            }}
            onCancel={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
